import { render, staticRenderFns } from "./QuoteApproval4PendingStateCard.vue?vue&type=template&id=b06c2cb8&"
import script from "./QuoteApproval4PendingStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteApproval4PendingStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports